var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-287 -2210) translate(0 2015) translate(165 155) translate(122 40)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#C4C8CE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M7.637 9c0-.313.037-.56.112-.744.075-.182.22-.353.432-.511.383-.227.699-.538.947-.934.248-.395.372-.829.372-1.3 0-.77-.227-1.38-.682-1.832C8.364 3.226 7.74 3 6.948 3c-.74 0-1.335.197-1.786.591-.451.394-.672.983-.662 1.767l.01.034h1.644c.006-.305.084-.535.234-.69.15-.154.337-.232.56-.232.276 0 .49.095.639.283.15.189.225.441.225.758 0 .305-.064.575-.192.809-.129.233-.304.43-.527.588-.433.343-.731.646-.894.91-.164.264-.247.658-.25 1.182h1.688zM7.5 11.432V10H6v1.432h1.5z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsHelp);
export default __webpack_public_path__ + "static/media/icons-help.19e308dd59d3f17a8cc10a7ccd120df1.svg";
export { ForwardRef as ReactComponent };